import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { FormsListComponent } from '@connect-services/client/components/management/forms/forms-list/forms-list.component';
import { ManagementMainPanelTitleComponent } from '@connect-services/client/components/management/management-main-panel-title/management-main-panel-title.component';
import { ManagementNoPermissionComponent } from '@connect-services/client/pages/management/no-permission/management-no-permission.component';
import { WarehouseAndFormsAccessPermissionsService } from '@connect-services/client/services/warehouse-and-forms-access-permissions.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsListComponent, ManagementMainPanelTitleComponent, ManagementNoPermissionComponent],
    selector: 'app-forms',
    templateUrl: './forms.component.html',
})
export class FormsComponent {
    protected readonly hasFormPermission = computed(() => {
        return this.warehouseAndFormsAccessPermissionsService.canAccessForms();
    });

    private readonly warehouseAndFormsAccessPermissionsService = inject(WarehouseAndFormsAccessPermissionsService);
}
